"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _extends = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/extends");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenState = exports.DropdownMenuTrigger = exports.DropdownMenuSubTrigger = exports.DropdownMenuSubContent = exports.DropdownMenuSub = exports.DropdownMenuShortcut = exports.DropdownMenuSeparator = exports.DropdownMenuRadioItem = exports.DropdownMenuRadioGroup = exports.DropdownMenuPortal = exports.DropdownMenuLabel = exports.DropdownMenuItem = exports.DropdownMenuGroup = exports.DropdownMenuContent = exports.DropdownMenuCheckboxItem = exports.DropdownMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var DropdownMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
var _cn = require("@udecode/cn");
var _classVarianceAuthority = require("class-variance-authority");
var _icons = require("../icons");
var _jsxRuntime = require("react/jsx-runtime");
/* Manually installed do not override */
/* eslint-disable react/jsx-pascal-case */

var DropdownMenu = exports.DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = exports.DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = exports.DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = exports.DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = exports.DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = exports.DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = exports.DropdownMenuSubTrigger = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    inset = _ref.inset,
    props = _objectWithoutProperties(_ref, ["children", "className", "inset"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DropdownMenuPrimitive.SubTrigger, _objectSpread({
    ref: ref,
    className: (0, _cn.cn)('flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent', 'data-[disabled]:pointer-events-none data-[disabled]:opacity-50', inset && 'pl-8', className)
  }, props, {
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Icons.chevronRight, {
      className: "ml-auto size-4"
    })]
  }));
});
var DropdownMenuSubContent = exports.DropdownMenuSubContent = (0, _cn.withCn)(DropdownMenuPrimitive.SubContent, 'z-[5000] min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2');
var DropdownMenuContentVariants = (0, _cn.withProps)(DropdownMenuPrimitive.Content, {
  className: (0, _cn.cn)('z-[5000] min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2'),
  sideOffset: 4
});
var DropdownMenuContent = exports.DropdownMenuContent = (0, _cn.withRef)(function (_ref2, ref) {
  var props = _extends({}, _ref2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownMenuPrimitive.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: 'plate-editor-wrapper',
      style: {
        position: 'absolute',
        zIndex: 5000
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownMenuContentVariants, _objectSpread({
        ref: ref
      }, props))
    })
  });
});
var menuItemVariants = (0, _classVarianceAuthority.cva)((0, _cn.cn)('relative flex h-9 cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors', 'focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50'), {
  variants: {
    inset: {
      true: 'pl-8'
    }
  }
});
var DropdownMenuItem = exports.DropdownMenuItem = (0, _cn.withVariants)(DropdownMenuPrimitive.Item, menuItemVariants, ['inset']);
var DropdownMenuCheckboxItem = exports.DropdownMenuCheckboxItem = (0, _cn.withRef)(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    props = _objectWithoutProperties(_ref3, ["children", "className"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DropdownMenuPrimitive.CheckboxItem, _objectSpread({
    ref: ref,
    className: (0, _cn.cn)('relative flex select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50', 'cursor-pointer', className)
  }, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "absolute left-2 flex size-3.5 items-center justify-center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownMenuPrimitive.ItemIndicator, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Icons.check, {
          className: "size-4"
        })
      })
    }), children]
  }));
});
var DropdownMenuRadioItem = exports.DropdownMenuRadioItem = (0, _cn.withRef)(function (_ref4, ref) {
  var children = _ref4.children,
    className = _ref4.className,
    hideIcon = _ref4.hideIcon,
    props = _objectWithoutProperties(_ref4, ["children", "className", "hideIcon"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DropdownMenuPrimitive.RadioItem, _objectSpread({
    ref: ref,
    className: (0, _cn.cn)('relative flex select-none items-center rounded-sm pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50', 'h-9 cursor-pointer px-2 data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground', className)
  }, props, {
    children: [!hideIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "absolute right-2 flex size-3.5 items-center justify-center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownMenuPrimitive.ItemIndicator, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Icons.check, {
          className: "size-4"
        })
      })
    }), children]
  }));
});
var dropdownMenuLabelVariants = (0, _classVarianceAuthority.cva)((0, _cn.cn)('select-none px-2 py-1.5 text-sm font-semibold'), {
  variants: {
    inset: {
      true: 'pl-8'
    }
  }
});
var DropdownMenuLabel = exports.DropdownMenuLabel = (0, _cn.withVariants)(DropdownMenuPrimitive.Label, dropdownMenuLabelVariants, ['inset']);
var DropdownMenuSeparator = exports.DropdownMenuSeparator = (0, _cn.withCn)(DropdownMenuPrimitive.Separator, '-mx-1 my-1 h-px bg-muted');
var DropdownMenuShortcut = exports.DropdownMenuShortcut = (0, _cn.withCn)((0, _cn.createPrimitiveElement)('span'), 'ml-auto text-xs tracking-widest opacity-60');
var useOpenState = function useOpenState() {
  var _ref5 = (0, _react.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    open = _ref6[0],
    setOpen = _ref6[1];
  var onOpenChange = (0, _react.useCallback)(function () {
    var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !open;
    setOpen(_value);
  }, [open]);
  return {
    open: open,
    onOpenChange: onOpenChange
  };
};
exports.useOpenState = useOpenState;